export const updateSeatPositions = (
  event: MouseEvent,
  selectedDots: Record<string, any>,
  data: any,
  dragOffsets: Record<string, { x: number; y: number }>
) => {
  for (const key of Object.keys(selectedDots)) {
    const index = selectedDots[key];
    const offset = dragOffsets[`seat:${index}`];
    if (offset && data.data[index]?.rect) {
      data.data[index].rect.x = (event.clientX - offset.x).toString();
      data.data[index].rect.y = (event.clientY - offset.y).toString();
    }
  }
};

export const updateTextFigurePositions = (
  event: MouseEvent,
  selectedTextFigures: Record<string, any>,
  data: any,
  dragOffsets: Record<string, { x: number; y: number }>
) => {
  for (const key of Object.keys(selectedTextFigures)) {
    const index = selectedTextFigures[key].split(":")[1];
    const offset = dragOffsets[`text:${index}`];
    const figure = data.properties.text?.[index];

    if (figure) {
      if (figure.properties.type === "polyline" && figure.rect.points) {
        const points = figure.rect.points.split(" ").map((point: string) => {
          const [x, y] = point.split(",").map(Number);
          return { x, y };
        });

        if (points.length > 0 && offset) {
          const newPoints = points.map(({ x, y }: { x: any; y: any }) => ({
            x: event.clientX - offset.x + (x - points[0].x),
            y: event.clientY - offset.y + (y - points[0].y),
          }));

          figure.rect.points = newPoints
            .map(({ x, y }: { x: any; y: any }) => `${x},${y}`)
            .join(" ");
        }
      } else if (offset && figure.rect) {
        figure.rect.x = (event.clientX - offset.x).toString();
        figure.rect.y = (event.clientY - offset.y).toString();
      }
    }
  }
};

export const updateFanZonePositions = (
  event: MouseEvent,
  selectedFanZones: Record<string, any>,
  data: any,
  dragOffsets: Record<string, { x: number; y: number }>
) => {
  for (const key of Object.keys(selectedFanZones)) {
    const index = Number(selectedFanZones[key].split(":")[1].split("-")[1]);
    const offset = dragOffsets[`fz:${index}`];
    const fanZone = data.hall_parts_data[index];

    const rect = fanZone?.properties?.rectangle?.rect;

    if (offset && rect) {
      rect.x = (event.clientX - offset.x).toString();
      rect.y = (event.clientY - offset.y).toString();
    }
  }
};
